import React from 'react';
import * as R from 'ramda';
// components
import { FormSectionHeader } from '../../../components/form-section-header';
// features
import BusinessHours, { withBusinessHours } from '../../business-hours';
// helpers/constants
import * as G from '../../../helpers';
//////////////////////////////////////////////////

export const BusinessHoursSection = withBusinessHours(({
  title,
  iconsML,
  maxWidth,
  fieldName,
  operationHour,
  componentType,
  handleOpenBusinessHours,
  handleRemoveBusinessHours,
}) => (
  <FormSectionHeader
    expanded={true}
    title={title || G.getWindowLocale('titles:business-hours', 'Business Hours')}
    action={G.ifElse(G.isNilOrEmpty(operationHour), handleOpenBusinessHours, null)}
  >
    <BusinessHours
      version={2}
      title={title}
      iconsML={iconsML}
      maxWidth={maxWidth}
      fieldName={fieldName}
      operationHour={operationHour}
      componentType={R.or(componentType, 'location')}
      handleOpenBusinessHours={handleOpenBusinessHours}
      handleRemoveBusinessHours={handleRemoveBusinessHours}
    />
  </FormSectionHeader>
));
